export const SESSION_COOKIE = "edm_session";
export const CSRF_COOKIE = "edm_csrf";
